// src/pages/Login.js
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { login as apiLogin } from "../services/api";

const ROLES = [
  { id: "admin",            label: "⚙️ Admin",    placeholder: "admin@pulse.ng" },
  { id: "rider",            label: "🏍️ Rider",    placeholder: "rider@pulse.ng" },
  { id: "customer_service", label: "🎧 CS Agent", placeholder: "cs@pulse.ng" },
];

const REDIRECT = {
  admin:            "/admin",
  rider:            "/rider",
  customer_service: "/cs",
};

export default function Login() {
  const [role, setRole]         = useState("admin");
  const [email, setEmail]       = useState("");
  const [password, setPassword] = useState("");
  const [error, setError]       = useState("");
  const [loading, setLoading]   = useState(false);
  const { login }               = useAuth();
  const navigate                = useNavigate();

  const handleSubmit = async () => {
    if (!email || !password) return setError("Please fill in all fields");
    setLoading(true);
    setError("");
    const data = await apiLogin(email, password);
    setLoading(false);
    if (data?.success) {
      login(data.user);
      navigate(REDIRECT[data.user.role] || "/");
    } else {
      setError(data?.message || "Invalid credentials");
    }
  };

  const currentRole = ROLES.find(r => r.id === role);

  return (
    <div style={{
      minHeight: "90vh", background: "#F7FAFB",
      display: "flex", alignItems: "center",
      justifyContent: "center", padding: 24
    }}>
      <div style={{ width: "100%", maxWidth: 420 }}>

        {/* Logo */}
        <div style={{ textAlign: "center", marginBottom: 36 }}>
          <img src="/logo.jpeg" alt="Pulse Logistics"
            style={{ height: 44, width: "auto", margin: "0 auto" }}
            onError={e => e.target.style.display = "none"}
          />
          <h2 style={{
            fontFamily: "'Syne',sans-serif", fontWeight: 800,
            fontSize: 26, color: "#0B1E3D", marginTop: 20, marginBottom: 6
          }}>
            Welcome back
          </h2>
          <p style={{ color: "#6B7280", fontSize: 14 }}>
            Sign in to your Pulse Logistics portal
          </p>
        </div>

        <div className="card" style={{ boxShadow: "0 4px 24px rgba(0,0,0,.08)" }}>

          {/* Role toggle */}
          <div style={{
            display: "grid", gridTemplateColumns: "1fr 1fr 1fr",
            background: "#EEF4F7", borderRadius: 8, padding: 4, marginBottom: 24
          }}>
            {ROLES.map(r => (
              <button key={r.id}
                onClick={() => { setRole(r.id); setEmail(""); setError(""); }}
                style={{
                  padding: "9px 4px", borderRadius: 6, border: "none",
                  cursor: "pointer", fontWeight: 600, fontSize: 12,
                  fontFamily: "'Inter',sans-serif", transition: "all .2s",
                  background: role === r.id
                    ? "linear-gradient(135deg,#00C6D7,#00A896)"
                    : "transparent",
                  color: role === r.id ? "#fff" : "#6B7280",
                  boxShadow: role === r.id ? "0 2px 8px rgba(0,198,215,.25)" : "none",
                  whiteSpace: "nowrap",
                }}>
                {r.label}
              </button>
            ))}
          </div>

          {/* Email */}
          <div className="form-group">
            <label>Email Address</label>
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder={currentRole?.placeholder}
            />
          </div>

          {/* Password */}
          <div className="form-group">
            <label>Password</label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="••••••••"
              onKeyDown={e => e.key === "Enter" && handleSubmit()}
            />
          </div>

          {error && (
            <div className="alert alert-error">{error}</div>
          )}

          <button
            className="btn btn-primary btn-full"
            onClick={handleSubmit}
            disabled={loading}
            style={{ padding: 13 }}>
            {loading ? "Signing in…" : "Sign In →"}
          </button>
        </div>
      </div>
    </div>
  );
}